import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';

// /auth/login is unauthenticated: attaching a stale/foreign Bearer token to it is pointless, and running
// the 401 handler below on a wrong-password attempt would log out and redirect away from a session that
// might still be valid in another tab.
const isLoginRequest = (url: string) => url.endsWith('/auth/login');

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (isLoginRequest(req.url)) {
    return next(req);
  }

  const token = auth.accessToken;
  const authorizedReq = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  return next(authorizedReq).pipe(
    catchError((error) => {
      if (error.status === 401) {
        auth.logout();
        router.navigate(['/login']);
      }
      return throwError(() => error);
    })
  );
};
